import type { WorkflowStats } from "./types";

/** `part` as a share of `whole`; `null` when there is nothing to divide by (shown as a dash). */
export const shareOf = (part: number, whole: number): number | null => (whole > 0 ? part / whole : null);

/** Goal %: the runs that met the goal out of the runs that carried one (`goal_met` / `goal_tracked`); `null` before any run carried a goal. */
export const goalRate = (counts: Pick<WorkflowStats["counts"], "goal_met" | "goal_tracked">): number | null => shareOf(counts.goal_met, counts.goal_tracked);
